import { Chip } from 'primereact/chip';
import { Dropdown } from 'primereact/dropdown';
import { Panel } from 'primereact/panel';
import { TabPanel, TabView } from 'primereact/tabview';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

/* import { DelegateToast } from '../../components/delegateToast/DelegateToast'; */
import { EDSMyMetricTab } from '../../components/edsMyMetricTab/EDSMyMetricTab';
import MessageInfo from '../../components/messageInfo/MessageInfo';
import { PayoutApprovalsTable } from '../../components/payoutApprovalsTable/PayoutApprovalsTable';
import { PrimaryApprovalScorecardStatus } from '../../components/primaryApprovalScorecardStatus/PrimaryApprovalScorecardStatus';
import { ScoreCardDashboardViewTable } from '../../components/scoreCardDashboardTable/ScoreCardDashboardViewTable';
import { ScoreCardEds } from '../../components/scoreCardEds/ScoreCardEds';
import { ScoreCardFilter } from '../../components/scoreCardFilter/ScoreCardFilter';
import { useGetScorecardAgentsQuery } from '../../components/scoreCardFilter/scoreCardFilterSlice';
import { ScorecardDisputesTable } from '../../components/scorecardDisputesTable/ScorecardDisputesTable';
import { ConstScorecardRole } from '../../utils/typeConstants';
import {
    useGetScoreCardDisputesQuery,
    useGetTeamLeadScorecardAgentsQuery,
} from '../scorecardDashboard/scorecardDashboardSlice';
import { ScorecardPizzaTracker } from '../../components/scorecardPizzaTracker/ScorecardPizzaTracker';
import ScorecardClientKPI from '../../components/ScorecardClientKPI/ScorecardClientKPI';
import { loadSCfilDate } from '../../utils/dateStorage';

interface ScorecardType {
    name: string;
    code: string;
}

export const ManagerDashboard = () => {
    const [agentNumber, setAgentNumber] = useState<any>();
    const [agentName, setAgentName] = useState<any>();
    const [tlAgentData, setTlAgentData] = useState<any>([]);
    const [scoreCardDisputeData, setScoreCardDisputeData] = useState<any>([]);
    const [inputMonth, setMonth] = useState(new Date().getMonth() + 1);
    const [inputYear, setYear] = useState(new Date().getFullYear());
    const [supervisorNumber, setSupervisorNumber] = useState();
    const supervisorDisable = false;
    const inputReadonly = true;
    //const [inputScorecardVersion, setInputScorecardVersion] = useState<any>('');
    const [inputScorecardVersionId, setInputScorecardVersionId] = useState<any>(-1);
    const [myScoreCards, setMyScoreCards] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [selectedScorecardType, setSelectedScorecardType] = useState<ScorecardType | null>(null);
    const scorecardTypes: ScorecardType[] = [
        { name: 'Show Only My Reports', code: 'SOM' },
        { name: 'Show All Associates on the Scorecard', code: 'SAA' },
        { name: 'Show All Unapproved on the Scorecard', code: 'SAU' },
    ];

    const { tabid, scid } = useParams();

    const onScoreCardChange = (value: any) => {
        if (value !== undefined && value !== '' && value !== null) {
            setMonth(value.month);
            setYear(value.year);
            //setInputScorecardVersion(value.scorecardVersionId);
            setInputScorecardVersionId(value.scorecardVersionId);
        }
    };
    /* supervisorNumber DDL */
    const { data: scorecardSupervisorsData } = useGetScorecardAgentsQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersionId,
            scorecardRoleId: ConstScorecardRole.TEAM_LEAD,
        },
        { skip: !inputYear || !inputMonth || !inputScorecardVersionId }
    );
    const { data: scorecardAgentsData } = useGetScorecardAgentsQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersionId,
            scorecardRoleId: ConstScorecardRole.ASSOCIATE,
        },
        { skip: !inputYear || !inputMonth || !inputScorecardVersionId }
    );
    const { data: teamLeadScorecardAgentData, isFetching: mrgTLScAgentDataIsFetching } =
        useGetTeamLeadScorecardAgentsQuery(
            {
                year: inputYear,
                month: inputMonth,
                scorecardVersionId: inputScorecardVersionId,
            },
            { skip: !inputScorecardVersionId }
        );
    const { data: scoreCardDisputesData } = useGetScoreCardDisputesQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersionId,
        },
        { skip: !inputScorecardVersionId }
    );

    const onAgentNameChange = (e: any) => {
        setAgentName(e);
    };
    const SupervisorOnChange = (e: any) => {
        setSupervisorNumber(e.value);
    };
    useEffect(() => {
        const tlAgentsData: any = [];
        if (teamLeadScorecardAgentData?.data?.length > 0) {
            teamLeadScorecardAgentData.data.forEach((element: any) => {
                if (element.review_status_id === 3) {
                    tlAgentsData.push(element);
                }
            });
        }
        setTlAgentData({ data: tlAgentsData });
    }, [teamLeadScorecardAgentData]);
    useEffect(() => {
        const disputesData: any = [];
        if (scoreCardDisputesData?.data?.length > 0) {
            scoreCardDisputesData.data.forEach((element: any) => {
                if (element.disputeStatusID === 1) {
                    disputesData.push(element);
                }
            });
        }
        setScoreCardDisputeData(disputesData);
    }, [scoreCardDisputesData]);

    useEffect(() => {
        if (tabid) {
            setActiveIndex(Number(tabid));
        }
        if(scid){
            setInputScorecardVersionId(scid);
             window.localStorage.setItem('ScFilDdlScorecard', scid);
        }
        setAgentName(null);
        if (!tabid && !scid) {
            const storedDate = loadSCfilDate();
            if (storedDate) {
                setMonth(storedDate.getMonth() + 1);
                setYear(storedDate.getFullYear());
            }
        }
    }, []);

    useEffect(() => {
        //alert(inputScorecardVersionId+'in manager')
        if (activeIndex === 4) {
            setMyScoreCards(true);
        } else {
            setMyScoreCards(false);
        }
    }, [activeIndex]);

    const onTabChange = (e: any) => {
        setActiveIndex(e.index);
        if (e.index !== 4) {
            //4-Payout Approvals
            setMyScoreCards(false);
            setSelectedScorecardType(null);
            //setInputScorecardVersionId(inputScorecardVersion);
        } else if (e.index === 4) {
            setMyScoreCards(true);
            setSelectedScorecardType(scorecardTypes[0]);
            //alert(inputScorecardVersion+'in');
            //alert(inputScorecardVersionId+'in');
            //setInputScorecardVersionId(inputScorecardVersion);
        } else {
            setMyScoreCards(false);
            setSelectedScorecardType(scorecardTypes[0]);
            //setInputScorecardVersionId(inputScorecardVersion);
        }
    };
    return (
        <div>
            <ScoreCardFilter
                menuName={'ManagerDashboard'}
                agentNumber={setAgentNumber}
                scorecardData={onScoreCardChange}
                agentName={onAgentNameChange}
                filterSCValue={setInputScorecardVersionId}
                filterMonth={setMonth}
                filterYear={setYear}
                myScoreCards={myScoreCards}
                scorecardId={setInputScorecardVersionId}
            />
            {inputScorecardVersionId > 0 && (
                <Panel
                    header="Scorecard Status"
                    toggleable
                    className="card mt-4 me-4 ms-4 shadow bg-body rounded border-0"
                >
                    <ScorecardPizzaTracker
                        inputYear={inputYear}
                        inputMonth={inputMonth}
                        inputScorecardVersion={inputScorecardVersionId}
                        fromCompensation
                    />
                </Panel>
            )}
            <div className="card mt-4">
                {agentNumber != null ? (
                    ''
                ) : (
                    <div style={{ display: 'none' }}>
                        <div className="row mt-3">
                            <div className="col-3">
                                <p className="me-3 mt-3 ms-3" style={{ marginBottom: '-5px' }}>
                                    Select Team Lead
                                </p>
                                <Dropdown
                                    disabled={supervisorDisable}
                                    value={supervisorNumber}
                                    onChange={SupervisorOnChange}
                                    options={scorecardSupervisorsData?.data}
                                    optionValue={'agent_number'}
                                    optionLabel={'agent_name'}
                                    placeholder={'Select Team Lead'}
                                    className="custom-dropdown me-3 mt-3 ms-3"
                                />
                            </div>
                        </div>
                        <hr />
                    </div>
                )}

                <TabView activeIndex={activeIndex} onTabChange={onTabChange}>
                    <TabPanel header="MyMetric" leftIcon="metricsBtnIcon">
                        <EDSMyMetricTab
                            scorecardAgentsData={scorecardAgentsData?.data}
                            scorecardVersionId={inputScorecardVersionId}
                            empName={agentName}
                            inputMonth={inputMonth}
                            inputYear={inputYear}
                        />
                    </TabPanel>
                    <TabPanel header="Associate Dispute" leftIcon="disputeBtnIcon">
                        {tlAgentData?.data?.length > 0 ? (
                            <div className="row mt-4">
                                <div className="col-12">
                                    <div className="card shadow bg-body rounded border-0">
                                        <div className="card-body">
                                            <ScoreCardDashboardViewTable
                                                enableNavigateAgent={false}
                                                ScoreCardAgentdata={tlAgentData}
                                                inputMonth={inputMonth}
                                                inputYear={inputYear}
                                                isFetching={mrgTLScAgentDataIsFetching}
                                                scorecardVersion={inputScorecardVersionId}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <MessageInfo
                                title="No results found."
                                message="Try adjusting the Scorecard filters above."
                                rowHeight="15vh"
                            />
                        )}
                    </TabPanel>
                    <TabPanel header="Scorecard" leftIcon="scorecardTabBtnIcon">
                        <ScoreCardEds
                            inputMonth={inputMonth}
                            inputYear={inputYear}
                            inputScorecardVersion={inputScorecardVersionId}
                        />
                    </TabPanel>
                    <TabPanel header="Scorecard Dispute" leftIcon="disputeBtnIcon">
                        {scoreCardDisputeData.length > 0 && inputScorecardVersionId !== null ? (
                            <ScorecardDisputesTable
                                scorecardVersion={inputScorecardVersionId}
                                data={scoreCardDisputeData}
                                isSubTab
                            />
                        ) : (
                            <MessageInfo
                                title="No results found."
                                message="Try adjusting the Scorecard filters above."
                                rowHeight="15vh"
                            />
                        )}
                    </TabPanel>
                    <TabPanel header="Payout Approval" leftIcon="payoutIcon">
                        <Panel
                            header="Payout Approvals"
                            toggleable
                            className="card mt-1 ms-1 me-1 shadow bg-body rounded border-0"
                        >
                            <Dropdown
                                value={selectedScorecardType}
                                onChange={(e) => setSelectedScorecardType(e.value)}
                                options={scorecardTypes}
                                optionLabel="name"
                                placeholder="Select"
                                className="custom-dropdown w-full md:w-14rem"
                            />
                            <Chip label="Choose “Show All” to include Agents who moved off the Scorecard." />
                            <PayoutApprovalsTable
                                month={inputMonth}
                                year={inputYear}
                                scorecardversion={inputScorecardVersionId}
                                ApprovalType="Manager"
                                isUnapproved={selectedScorecardType?.code === 'SAU'}
                                isMyReports={selectedScorecardType?.code === 'SOM'}
                            />
                        </Panel>
                    </TabPanel>
                    <TabPanel header="Approval Windows" leftIcon="windowsTabBtnIcon">
                        <PrimaryApprovalScorecardStatus
                            inputScorecardVersion={inputScorecardVersionId}
                            inputYear={inputYear}
                            inputMonth={inputMonth}
                            inputReadonly={inputReadonly}
                            via='ManagerDashboard'
                        />
                    </TabPanel>
                    <TabPanel header="Client KPI" leftIcon="payoutIcon">
                        <ScorecardClientKPI
                            inputYear={inputYear}
                            inputMonth={inputMonth}
                            scorecardVersion={inputScorecardVersionId}
                        />
                    </TabPanel>
                </TabView>
            </div>
            {/* <DelegateToast /> */}
        </div>
    );
};
